import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useSelector } from 'react-redux';
import { Form } from '@unform/web';
import { toast } from 'react-toastify';
import { FiPlus, FiSearch, FiCreditCard } from 'react-icons/fi';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { useNavigate } from 'react-router-dom';

import api from 'services/api';
import { Role } from 'utils/variables';
import AppError from 'utils/AppError';

import { Programa as ProgramaItem } from 'pages/@types';
import ProgramaStore from './store';

import Card from 'components/Card';
import Button from 'components/Button';
import Input from 'components/Input';
import Loader from 'components/ContentLoader/GenericLoader';

import { Td } from 'styles/global';
import { Container, ColumnContent, Table } from './styles';

export default function Programa() {
  // react-router-dom
  const navigate = useNavigate();
  /*
   * STATES
   */
  const [programas, setProgramas] = useState<ProgramaItem[]>([]);
  const [selected, setSelected] = useState({} as ProgramaItem);
  const [filtro, setFiltro] = useState('');
  const [editMode, setEditMode] = useState(false);
  const [loading, setLoading] = useState(false);
  const { profile } = useSelector((state: any) => state.usuario);

  const handleClearForm = useCallback(async () => {
    setSelected({} as ProgramaItem);
    setEditMode(true);
  }, []);

  const filteredProgramas = programas.filter(
    p =>
      p.nome.toUpperCase().includes(filtro.toUpperCase()) ||
      (p.mnemonico &&
        p.mnemonico.toUpperCase().includes(filtro.toUpperCase())) ||
      (p.sigla && p.sigla.toUpperCase().includes(filtro.toUpperCase())),
  );

  /**
   * USE EFFECT
   */
  useEffect(() => {
    const controller = new AbortController();
    async function loadProgramas() {
      setLoading(true);
      try {
        const response = await api.get('/programas', {
          signal: controller.signal,
        });
        if (response && response.data) setProgramas(response.data);
        else
          toast.error('Falha de comunicação com o sistema', {
            toastId: 'API Offline',
          });
      } catch (e) {
        if (e instanceof Error) toast.error(e.message);
        else if (e instanceof AppError) toast.error(e.message);
        else {
          const appError = e as AppError;
          if (appError.message)
            toast.error(appError.message, {
              toastId: appError.message,
            });
          else toast.error('Erro inesperado');
        }
      }
      setLoading(false);
    }

    loadProgramas();

    return () => {
      controller.abort();
    };
  }, []);

  return (
    <Container>
      <header>
        <Button
          color="primary"
          onClick={() => handleClearForm()}
          disabled={loading}
          tooltip="Criar novo programa"
        >
          <FiPlus /> Novo programa
        </Button>
        <Button
          color="primary"
          href={'/programas/intervaloeleicao'}
          disabled={loading || ![Role.OPEC, Role.ADMIN].includes(profile.role)}
        >
          <FiCreditCard /> Intervalo Eleição
        </Button>
      </header>
      <ColumnContent $columns={editMode ? '2fr 1fr' : '1fr'}>
        <Card>
          <header>
            <h4>LISTA DE PROGRAMAS</h4>

            <div>
              <Form onSubmit={() => {}}>
                <Input
                  name="searchLocal"
                  placeholder="Buscar na Tabela"
                  icon={<FiSearch />}
                  onChange={e => setFiltro(e.target.value)}
                />
              </Form>
            </div>
          </header>
          <PerfectScrollbar
            style={{ height: 'calc(100vh - 220px)', padding: '0 15px' }}
          >
            {loading ? (
              <Loader />
            ) : (
              <Table>
                <thead>
                  <tr>
                    <th>PROGRAMA</th>
                    <th style={{ width: 100, textAlign: 'center' }}>GÊNERO</th>
                    <th style={{ width: 120, textAlign: 'center' }}>
                      EXIB. LOCAL
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {filteredProgramas.map(p => (
                    <tr
                      key={p.id}
                      onClick={
                        () => {
                          setSelected(p);
                          setEditMode(true);
                        }
                        // handleFillForm(p)
                      }
                    >
                      <Td>
                        {p.mnemonico}{' '}
                        <strong>
                          ({p.sigla ? p.sigla + ' - ' + p.nome : p.nome})
                        </strong>
                      </Td>
                      <td style={{ textAlign: 'center' }}>{p.genero}</td>
                      <td style={{ textAlign: 'center' }}>
                        {p.exibicaolocal ? 'SIM' : 'NÃO'}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
          </PerfectScrollbar>
        </Card>
        {editMode && selected && (
          <ProgramaStore
            selected={selected}
            setProgramas={setProgramas}
            setEditMode={setEditMode}
            setSelected={setSelected}
          />
        )}
      </ColumnContent>
    </Container>
  );
}
